import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { DashboardLayout } from '../../app/layouts/DashboardLayout';
import { MEMBER_NAV } from '../../constants/nav';
import { HelpView } from '../../components/faq/HelpView';
import { fetchPublicFaqs, fetchPublicHelp } from '../../features/faq/api/faq';
import type { Faq, HelpSettings } from '../../types';

export default function MemberHelpPage() {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [help, setHelp] = useState<HelpSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchPublicFaqs(), fetchPublicHelp()]).then(([f, h]) => { setFaqs(f); setHelp(h); }).finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout navItems={MEMBER_NAV} title="FAQ & Bantuan">
      <div className="max-w-5xl">
        {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} /></div> : <HelpView faqs={faqs} help={help} />}
      </div>
    </DashboardLayout>
  );
}
